import {
	FeeTierDisplayUnit,
	StakedTierSelectValue,
} from 'src/components/Modals/FeeTierModal/types';
import { useSpotMarketsLookup } from 'src/hooks/spotMarkets/useSpotMarketsLookup';
import { DRIFT_TOKEN_BANK_INDEX } from 'src/environmentVariables/EnvironmentVariables';
import { useCallback } from 'react';
import useModal from 'src/components/Modals/hooks/useModal';

interface Params {
	setDisplayUnit: (value: FeeTierDisplayUnit) => void;
	setSelectedStakedTier: (value: StakedTierSelectValue) => void;
}

export default function useFeeTierModalHandlers({
	setDisplayUnit,
	setSelectedStakedTier,
}: Params) {
	const { push, hide } = useModal();
	const driftSpotMarket = useSpotMarketsLookup()[DRIFT_TOKEN_BANK_INDEX];

	const handleStakeClick = useCallback(() => {
		push({
			type: 'stake',
			props: { isDriftStaking: true, selectedIfStakeMarket: driftSpotMarket },
		});
	}, [driftSpotMarket, push]);

	const handleChangeDisplayUnit = useCallback(
		(value: FeeTierDisplayUnit) => {
			setDisplayUnit(value);
		},
		[setDisplayUnit]
	);

	const handleChangeStakedTier = useCallback(
		(value: StakedTierSelectValue) => {
			setSelectedStakedTier(value);
		},
		[setSelectedStakedTier]
	);

	return {
		handleStakeClick,
		handleChangeDisplayUnit,
		handleChangeStakedTier,
		handleCloseModal: hide,
	};
}
